import type { Locale } from '@/i18n/translations';

export const donorKeys = {
  protected: ['donor'] as const,
  deletionScope: ['donor', 'deletion'] as const,
  legacyDocuments: (id: string, account: string | undefined, locale: Locale) =>
    ['donor', 'legacy-documents', account, locale, id] as const,
  checkout: (
    id: string,
    mode: string,
    account: string | undefined,
    locale: Locale,
    actor: string,
  ) => ['donor', 'checkout', id, mode, account, locale, actor] as const,
  documents: (
    id: string,
    mode: string,
    account: string | undefined,
    locale: Locale,
    actor: string,
  ) => ['donor', 'documents', id, mode, account, locale, actor] as const,
  history: (account: string | undefined, locale: Locale, page: number) =>
    ['donor', 'history', account, locale, page] as const,
  otherGifts: (account: string | undefined, locale: Locale, page: number) =>
    ['donor', 'other-gifts', account, locale, page] as const,
  favorites: (account: string | undefined, locale: Locale, page: number) =>
    ['donor', 'favorites', account, locale, page] as const,
  exports: (account: string | undefined, locale: Locale) =>
    ['donor', 'exports', account, locale] as const,
  export: (id: string | undefined, account: string | undefined, locale: Locale) =>
    ['donor', 'export', id, account, locale] as const,
  deletion: (account: string | undefined, locale: Locale) =>
    ['donor', 'deletion', account, locale] as const,
};

// View data may be briefly reused while mounted; financial confirmation stays fresh in its own queries.
export const donorViewOptions = {
  staleTime: 30_000,
  gcTime: 0,
  retry: false,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
} as const;
